import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { NoteDbMapperService } from "@e-forsyning/common/note";

import { OpgaveNoterData } from "./model/opgave-noter-data.model";

@Injectable({ providedIn: "root" })
export class OpgaveNoteMapper {
    constructor(private readonly noteMapper: NoteDbMapperService) {}

    public dtoToOpgaveNoterData(data: any, bilagUrlTemplate: string): OpgaveNoterData {
        const result: any = {
            ...data,
            noter: (data.noter as any[]).map((note) => this.noteMapper.dbToNote(note, bilagUrlTemplate)).sort((a, b) => b.noteId - a.noteId)
        };
        return result as OpgaveNoterData;
    }

    public opgaveNoterDataToDto(data: OpgaveNoterData): any {
        const result = {
            ...data,
            noter: data.noter.map((note) => this.noteMapper.noteToDb(note))
        };
        return result;
    }

    public getBilagUrlTemplate(): Observable<string> {
        return this.noteMapper.getBilagUrlTemplate();
    }
}
